import axios from "axios"

async function getDevices(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-devices`
    })
}

async function getDevice(workspaceUuid: string, id: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-devices/${id}`
    })
}

export {
    getDevice,
    getDevices
}

